<template>
  <div>
    <nav class="bg-white px-8 pt-2">
      <div class="-mb-px flex">
        <a v-for="tab in tabs" class="no-underline border-b-2 cursor-pointer border-transparent uppercase tracking-wide py-3 mr-8 font-medium" :class="{ 'text-blue-500': tab.isActive, 'text-gray-700': tab.isActive == false }" @click="selectTab(tab)" :key="tab.name">
          {{ tab.name }}
        </a>
      </div>
    </nav>

    <div>
      <slot></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: "tabs",
  data() {
    return { tabs: [] };
  },
  mounted() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });
    }
  }
};
</script>
